//@flow

import bemify from 'bemify-js';
import React, { Component } from 'react';

import { createRenderCallback } from '@zapier/legacy-components';

import AccountDropdown from 'web-ssr/app/common/components/AccountDropdown';
import AccountDropdownToggler from 'web-ssr/app/common/components/AccountDropdownToggler';
import { DropdownStateful } from 'web-ssr/app/common/components/DropdownMenu';
import 'web-ssr/app/common/components/AccountMenu/AccountMenu.scss';

const bem = bemify('account-menu');

type Props = {
  accountId: number,
  className?: string,
  isDeveloper: boolean,
  onAccountMenuDropdownOpen?: () => void,
  onMount?: () => void,
  onUpgradeClick?: () => void,
  userAvatarUrl: string,
  userName: string,
};

class AccountMenu extends Component<Props> {
  UNSAFE_componentWillMount() {
    if (this.props.onMount) {
      this.props.onMount();
    }
  }

  render() {
    const { props } = this;
    return (
      <DropdownStateful
        className={bem(props.className)}
        onOpen={props.onAccountMenuDropdownOpen}
        renderMenu={createRenderCallback(AccountDropdown, props)}
        renderToggle={createRenderCallback(AccountDropdownToggler, {
          accountId: props.accountId,
          className: bem('__toggler'),
          title: props.userName,
          hideArrow: true,
          hideDetails: true,
        })}
      />
    );
  }
}

export default AccountMenu;
